import Vue from 'vue'
import Vuex from 'vuex'
//import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import router from '../router';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appversion: '1.6.19b',
    usuario:{
      user: '',
      name: '',      
      resource: '',
      guid: ''      
    },
    appconfig:{
      appname1: '',
      appname2: '',
      showAppSufix: false,
      version: '',
      revision: '',
      servicesLanguage: '',
      ProyectoGeneral: '',
      TareaGeneral: '',
      taskDescription: '',
      taskItemNo : ''
    },
    usuarioLogeado : false,
    dialogParte: false,
    dialogProyecto: false,
    dialogInputHoras: false,
    dialogInputHorasPersonal: false,
    dialogSignature: false,
    dialogSignatureHourStart: false,
    dialogSignatureHourEnd: false,
    dialogSignatureCustomer: false,
    dialogParteDetalle: false,
    dialogExtraInfo: false,
    dialogSummary: false,
    dialogDocumentImages: false,
    dialogConfirmDriver: false,
    dialogLogout: false,
    allJobs: [],
    jobs: [],
    jobTasks: [],
    fechaParte: '',
    proyecto : '',
    tarea: '',
    lineasParte: [],
    eventos: [],
    customers: [],
    customerFilter: '',
    uom: '',
    uoms: [],
    loginError : false,
    loginErrorMsg : '',
    familias: [],
    familia: '',
    workTypes: [],
    workType: '',
    hourStart: undefined,
    hourEnd: undefined,
    hourStartInvoiceable: undefined,
    hourEndInvoiceable: undefined,
    signatureOrder: '',
    signatureStart: '',
    signatureEnd: '',
    signatureCustomer: '',
    signatureServices: '',
    resourcesAditional: [],
    resources: [],
    resource: '',
    parteDetalle: '',
    parteDetalleObject: undefined,
    indexEditLine: -1,
    codsIntClientes: [],
    codIntCliente: '',
    origenes:[],
    origen:'',
    destinos:[],
    destino:'',
    residuos:[],
    residuo:'',
    otroResiduo:'',
    taskDescription:'',
    note:'',
    images: [],
    storedImages: [],
    users: [],
    user: [],
    relations: [],
    relation: '',
    driver: false,
    revision: false,
    albaranFisico: '',
    dieta: false,
    globalAlert: false,
    globalAlertContent: '',
    isLoading: false,
    refCalendar: null,
    activeAPIurl: '/api/',
    //activeAPIurl: 'http://localhost:5000/'
  },
  mutations: {
    saveisLoading(state,data){
      state.isLoading = data;
    },
    saveLogin(state, data){
      state.usuario = data;
      state.usuarioLogeado = true;
    },
    saveAppConfig(state,data){
      state.appconfig = data;
    },  
    saveJobs(state,data){
      state.jobs = data;
    }, 
    saveAllJobs(state,data){
      state.allJobs = data;
    },  
    saveJob(state,data){
      state.proyecto = data;
    }, 
    saveFamilias(state,data){
      state.familias = data;
    },
    saveFamilia(state,data){
      state.familia = data;
    },
    saveJobTasks(state,data){
      state.jobTasks = data;
    }, 
    saveJobTask(state,data){
      state.tarea = data;
    }, 
    saveWorkTypes(state,data){
      state.workTypes = data;
    }, 
    saveWorkType(state,data){
      state.workType = data;
    }, 
    saveDocumentDate(state,data){
      state.fechaParte = new Date(data);
    }, 
    saveCustomers(state,data){
      state.customers = data;
    }, 
    saveCustomerFilter(state,data){
      state.customerFilter = data;
    },
    saveUom(state,data){
      state.uom = data;
    },
    saveUoms(state,data){
      state.uoms = data;
    },
    saveHourStart(state,data){
      state.hourStart = data;
    },
    saveHourEnd(state,data){
      state.hourEnd = data;
    },
    saveHourStartInvoiceable(state,data){
      state.hourStartInvoiceable = data;
    },
    saveHourEndInvoiceable(state,data){
      state.hourEndInvoiceable = data;
    },
    saveParteDetalle(state,data){
      state.parteDetalle = data;
    },
    saveParteDetalleObject(state,data){
      state.parteDetalleObject = data;
    },
    saveResourcesAditional(state,data){
      state.resourcesAditional = data;
    },
    saveResources(state,data){
      state.resources = data;
    },
    saveResource(state,data){
      state.resource = data;
    },
    saveOrigenes(state,data){
      state.origenes = data;
    },
    saveOrigen(state,data){
      state.origen = data;
    },
    saveDestinos(state,data){
      state.destinos = data;
    },
    saveDestino(state,data){
      state.destino = data;
    },
    saveResiduos(state,data){
      state.residuos = data;
    },
    saveResiduo(state,data){
      state.residuo = data;
    },
    saveOtroResiduo(state,data){
      state.otroResiduo = data;
    },
    saveCodIntCliente(state,data){
      state.codIntCliente = data;
    },
    saveCodsIntClientes(state,data){
      state.codsIntClientes = data;
    },
    saveNote(state,data){
      state.note = data;
    },
    saveTaskDescription(state,data){
      state.taskDescription = data;
    },
    saveUsers(state,data){
      state.users = data;
    },
    saveUser(state,data){
      state.user = data;
    },
    saveRelations(state,data){
      state.relations = data;
    },
    saveRelation(state,data){
      state.relation = data;
    },
    saveImages(state,data){
      state.images = data;
    },
    saveStoredImages(state,data){
      state.storedImages = data;
    },
    saveIndexEditLine(state,data){
      state.indexEditLine = data;
    },
    saveGlobalAlert(state,data){
      state.globalAlert = data;
    },
    saveGlobalAlertContent(state,data){
      state.globalAlertContent = data;
    },
    saveDriver(state,data){
      state.driver = data;
    },
    addLine(state,data){
      state.lineasParte.push(data);
      state.lineasParte = state.lineasParte.sort(function (a,b) {
        if (a.lineNo > b.lineNo)
          return 1; 
        if (a.lineNo < b.lineNo)
          return -1;
        return 0;
      });
    },
    setLines(state,data){
      state.lineasParte = data;
    },
    resetLines(state){
      state.lineasParte = [];
    },
    resetDataAfterSuccessfulCreation(state){
      state.lineasParte = [];
      state.proyecto = '';
      state.tarea = '';      
      state.uom = '';
      state.uoms = [];    
      state.customers = [];
      state.customerFilter = '';
      state.familias = [];
      state.familia = '';
      state.workTypes = [];
      state.workType = '';
      state.hourStart = undefined;
      state.hourEnd = undefined;
      state.signatureCustomer = '';
      state.signatureOrder = '';
      state.signatureStart = '';
      state.signatureEnd = '';
      state.signatureServices = '';
      state.resourcesAditional = [];
      state.resources = [];
      state.resource = '';
      state.codIntCliente = '';
      state.origenes = [];
      state.origen = '';
      state.destinos = [];
      state.destino = '';
      state.residuos = [];
      state.residuo = '';
      state.otroResiduo = '';
      state.taskDescription = '';
      state.parteDetalle = '';
      state.parteDetalleObject = undefined;
      state.storedImages = [];
      state.users = [];
      state.user = [];
      state.relations = [];
      state.relation = '';
      state.globalAlert = false;
      state.globalAlertContent = '';
      state.note = '';
      state.revision = false;
      state.albaranFisico = '';
      state.dieta = false;
      this.commit("saveResourcesAditional",state.resourcesAditional);
    },
    saveEvents(state, val){
      state.eventos = val;
    },
    saveSignature(state,data){
      state.signatureOrder = data;
    },
    saveSignatureStart(state,data){
      state.signatureStart = data;
    },
    saveSignatureEnd(state,data){
      state.signatureEnd = data;
    },
    saveSignatureCustomer(state,data){
      state.signatureCustomer = data;
    },
    saveSignatureServices(state,data){
      state.signatureServices = data;
    },
    saveActiveAPIUrl(state,data){
      state.activeAPIurl = data;
    }, 
    saveRevision(state, val){
      state.revision = val;
    },
    saveAlbaranFisico(state, val){
      state.albaranFisico = val;
    },
    saveDieta(state, val){
      state.dieta = val;
    },
    saveRefCalendar(state,val){
      state.refCalendar = val;
    },
    addEvent(state, val){
      state.eventos.push(val);
    },
    logout(state){
      state.usuarioLogeado = false;
      state.dialogParte= false,
      state.dialogProyecto= false,
      state.dialogInputHoras= false,
      state.dialogInputHorasPersonal= false,
      state.dialogSignature= false,
      state.dialogSignatureHourStart= false,
      state.dialogSignatureHourEnd= false,
      state.dialogSignatureCustomer= false,
      state.dialogParteDetalle= false,
      state.dialogExtraInfo= false,
      state.dialogSummary= false,
      state.dialogDocumentImages= false,
      state.dialogConfirmDriver= false,
      state.dialogLogout= false,
      state.usuario = {
        user: '',
        name: '',      
        resource: '',
        guid: ''      
      };
      router.push('/');
    },
  },
  actions: {
  },
  modules: {
  },
  //Variables que se guardan de manera permantente incluso si se actualiza la página
  plugins: [createPersistedState({
    key: 'AppData',
    paths: ['usuario','usuarioLogeado','appconfig','jobs','allJobs','jobTasks','proyecto','tarea','lineasParte', 'fechaParte','eventos','uom','uoms','familias','familia','workTypes',
    'workType','hourStart','hourEnd','signatureOrder','signatureStart','signatureEnd','signatureCustomer','signatureServices','resourcesAditional','resources','resource','parteDetalle','parteDetalleObject','indexEditLine',
    'codsIntClientes','codIntCliente','albaranFisico','origenes','origen','destinos','destino','residuos','otroResiduo','taskDescription','note','images','storedImages','users','user',
    'relations','relation','driver','activeAPIurl','dieta']
  })] 
})
